<div class="modal-header">
  <h4 class="modal-title fw-normal">Edit Attachment</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  @if (saveError()) {
    <p class="alert alert-danger">{{ saveError() }}</p>
  }
  <form [formGroup]="form">
    <div class="mb-3">
      <label for="groupId" class="form-label">Group</label>
      @if (groupsLoadError()) {
        <p class="alert alert-warning mb-0">Failed to load groups.</p>
      } @else {
        <select id="groupId" class="form-select" formControlName="groupId" [disabled]="isLoading()">
          <option value="">No group</option>
          @for (group of groups(); track group.id) {
            <option [value]="group.id">{{ group.groupName }}</option>
          }
        </select>
      }
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">Description</label>
      <textarea
        id="description"
        class="form-control"
        formControlName="description"
        rows="3"
        maxlength="500"
      ></textarea>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="save()"
    [disabled]="form.invalid || isSaving()"
  >
    @if (isSaving()) {
      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      Saving...
    } @else {
      Save
    }
  </button>
</div>
